<script setup lang="ts">
definePageMeta({
  layout: false,
  middleware: 'guest'
})
</script>
<template>
  <div>
    <AuthLogin />
  </div>
</template>
